import React from 'react';
import Layout from './components/Layout';
import { initializeIcons } from '@fluentui/react';
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';
import Home from './Pages/Home';
import Blog from './Pages/Blog';
// import Instructions from './Pages/Instructions';
import AccountPage from './Pages/AccountPage';
// import Svor from './Pages/Svor';
import Admin from './Pages/Administration';
// import RouteAccess from './components/Routes/RouteAccess';
import RouteForAdmin from './components/Routes/RouteForAdmin';
import RouteForUsers from './components/Routes/RouteForUsers';
import  DistPage  from './Pages/Dist';
import  DocPage  from './Pages/DocPage';
import { PageProvider } from './hooks/PageContext';


initializeIcons();

const App: React.FC = () => {
  return (
    <Router>
       <PageProvider>
    <Routes>
      <Route path="/" element={<Layout><Outlet /></Layout>}>
        <Route index element={<Home />} />
        <Route path="Home" element={<Home />} />
        <Route path="Blog" element={<Blog />} />
        <Route path="DocPage" element={<DocPage />} />
        {/*<Route path="Instructions" element={<Instructions />} />*/}
        <Route path="Dist" element={<DistPage />} />
        <Route path="Blog/:noteId?" element={<Blog />} /> 
        {/*<Route path="Svor"
               element={
                <RouteAccess>
                  <Svor />
                </RouteAccess> } /> */}       
        <Route path="Administration"
               element={
                <RouteForAdmin>
                  <Admin />
                </RouteForAdmin>  } />
        <Route path="AccountPage"
               element={
                <RouteForUsers>
                  <AccountPage />
                </RouteForUsers>  } /> 
       <Route path="/account/edit/:id" element={<AccountPage />} />
      </Route>
    </Routes>
   </PageProvider>
   </Router>
  );
};

export default App;